import React from 'react';
import Footer from '../Footer/Footer';
import HeaderAuth from '../Headers/HeaderAuth';
import { JumpToContentAnchor } from '../Headers/SkipToContent';
import { Fragment } from 'react';

const LayoutEmpty = (props) => {
  return (
    <Fragment>

      <HeaderAuth classNames={['headerContainer']}></HeaderAuth>

      <main
        role="main"
        aria-describedby="app_page_title"
        className='app-layout-empty'>
        <JumpToContentAnchor />
        {props.children}
      </main>
      
      <Footer className={'footerContainer render-body-container render-active'}></Footer>

    </Fragment>
  );
}

export default LayoutEmpty;
